import type {
  CreateCostCenterRequest,
  CreateCostCenterResult,
  LC_CreateCostCenterIn,
  LC_CreateCostCenterOut,
} from '../types';


export function mapCreateCostCenterToTransport(
  request: CreateCostCenterRequest,
): LC_CreateCostCenterIn {
  return {
    costCenterCode: request.code,
    costCenterName: request.name,
    description: request.description,
  };
}

export function mapCreateCostCenterFromTransport(
  transport: LC_CreateCostCenterOut,
): CreateCostCenterResult {
  return {
    id: transport.costCenterId,
    code: transport.costCenterCode,
    name: transport.costCenterName,
    description: transport.description,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
  };
}
